import React, { FC, memo, ReactNode, useEffect, useRef, useState } from 'react';
import { CloseButton, Modal } from 'react-bootstrap';
import { useRouter } from 'next/router';

interface IProps {
    modalName: string
    className: string
    modalSize?: 'sm' | 'lg' | 'xl'
    closeModal: () => void
    show: boolean
    children: ReactNode
    Title?: ReactNode | null
}

const CustomModal: FC<IProps> = ({ modalName, className, modalSize, closeModal, show, children, Title }) => {
  const [ showModal, setShowModal ] = useState<boolean>( show || false );
  const router = useRouter();
  const hasHash = router.asPath.includes( '#' )
  // true only while this modal has its own #modalName entry in the browser history
  const pushedHistoryRef = useRef<boolean>( false )

  const openHandler = () => {
    if ( !hasHash ) {
      router.push({
        hash: modalName + ''
      }, undefined, { scroll: false })
      pushedHistoryRef.current = true
    }
    setShowModal( true );
  }

  const closeHandler = () => {
    closeModal();
    setShowModal( false );
    // go back only to undo this modal's own #hash entry. Modals opened by their parent (show={true}) add no
    // history entry, and going back there left the page or reopened the previous modal/article.
    if ( pushedHistoryRef.current ) {
      pushedHistoryRef.current = false
      router.back()
    }
  }
  // const clickOutSideHandler = () => {
  //   closeModal();
  //   setShowModal( false );
  // }


  // useEffect( () => {
  //   if ( show ) openHandler();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [show])

  // useEffect( () => {
  //   if ( !hasHash && showModal ) clickOutSideHandler();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [hasHash]);

  return (
    <Modal
      id={modalName}
      className={className}
      size={modalSize}
      show={show}
      onHide={closeHandler}
      animation={true}
      // onOverlayClick={clickOutSideHandler}
    >
      <Modal.Header>
        <CloseButton onClick={closeHandler}/>
        {Title}
      </Modal.Header>
      {children}
    </Modal>
  )
}

export default memo( CustomModal );
